import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "@material-ui/core/Button";
import Divider from '@material-ui/core/Divider';
import Grid from "@material-ui/core/Grid";
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import ClearIcon from "@material-ui/icons/Clear";

import moment from "moment";

//components
import ContentWrapper from "../../../containers/ContentWrapper";
//actions
import * as dialogActions from "../../../redux/actions/dialogactions";
import * as shootActions from "../../../redux/actions/shootsactions";
//constants
import * as shootTypes from "../../../redux/constants/ShootsActionTypes";
//services
import shootService from "../../../services/shootService";
import ConfirmationDialog from "../../Dialogs/ConfirmationDialog";
import ClientLanguageSection from "../ClientLanguageSection";
import ClientServicesSection from "../ClientServicesSection";
import ClientStaffSection from "../ClientStaffSection";
import SendToContractorDialog from "./SendToContractorDialog";

class DetailsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      failed: false,
      details: null,
      shooter: [],
      shots: [],
      staffs: [],
      services: [],
      languages: [],
      promptDialog: false,
      updatingShoot: false
    };
  }

  timeOut = null;

  componentDidMount() {
    this.props.shootActions.getShootStatus(
      this.props.match.params.name,
      this.props.match.params.date
    )
    this.getShootDetails();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.confirmDialog === false &&
      prevProps.confirmDialog === true
    ) {
      if(this.props.confirmChoice){
        switch (this.props.confirmAction) {
          case shootTypes.SHOOTS_MARK_SHOOT_COMPLETE:
            this.props.shootActions.markShootComplete(
              this.props.match.params.name,
              this.props.match.params.date,
              this.props.details
            )
            break;
        
          default:
            break;
        }
      }
    }
  }

  getShootDetails = async () => {
    console.log("getting shots")
    this.props.shootActions.getOneShoot(this.props.match.params.name, this.props.match.params.date);
  }

  initiateStartShoot = () => {
    this.props.shootActions.openStartShootDialog();
  };

  startShoot = async () => {
    return await shootService.updateShoot(
      {
        clinic: this.props.match.params.name,
        created_at: this.props.match.params.date
      },
      {
        address: this.props.details.address,
        date: this.props.details.date,
        status: "PENDING"
      }
    );
  };

  handlePromptDialog = () => {
    this.setState({
      promptDialog: !this.state.promptDialog
    });
  };

  markShootComplete = () => {
    this.props.dialogActions.openConfirmDialog(
      "Are you sure?",
      "You are about to mark this shoot as complete. Please confirm if you want to do this action.",
      shootTypes.SHOOTS_MARK_SHOOT_COMPLETE
    );
  };

  render() {
    return (
      <ContentWrapper hasPadding>
        {/* <Button
          variant="outlined"
          color="primary"
          onClick={() => this.props.history.replace("/shoots")}
        >
          Back
        </Button> */}
        <Toolbar variant="dense" style={{padding: '10px 5px'}} disableGutters={true}>
          <Tooltip title="Cancel">
            <IconButton onClick={() => this.props.history.replace("/shoots")} aria-label="cancel" color="secondary">
              <ClearIcon/>
            </IconButton>
          </Tooltip>
          <div style={{flexGrow: 1}} />
          {/* <Tooltip title="Save Shoot">
            <Button variant="fab" onClick={this.confirmSaveShoot} color="primary" mini aria-label="Add" style={{marginLeft: '5px', boxShadow: 'none'}}>
              <SaveIcon />
            </Button>
          </Tooltip> */}
          {(this.props.fetching && !this.props.fetched) || this.props.status === null ? null : (
            <>
          {this.props.details.status === "CHECKING" ? (
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={this.markShootComplete}
            >
              Mark as Complete
            </Button>
          ) : this.props.details.status === "DRAFT" ? (
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={this.initiateStartShoot}
            >
              Start Shoot
            </Button>
          ) : null}
          </>
          )}
        </Toolbar>
        <Divider/>
        
        
          <>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Grid item xs={12} md={6} sm={8} style={{ marginTop: 50 }}>
                  <Typography
                    component="span"
                    variant="h6"
                    color="inherit"
                  >
                    Shoot Details
                  </Typography>
                {this.props.fetching || this.props.status === null? (
                  <LinearProgress color="primary" style={{ height: 2, marginTop: 20 }} />
                ) : null}
                {(this.props.fetching && !this.props.fetched) || this.props.status === null ? null : (
                <Paper style={
                  this.props.fetching || this.props.status === null?
                  { padding: 24 }
                  :
                  { padding: 24, marginTop: 20 }
                  }>
                  <Grid container spacing={10}>
                    <Grid item xs={12} md={6} sm={6}>
                      <Typography variant="h5">Client Name</Typography>
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        style={{ paddingLeft: 10 }}
                      >
                        {this.props.details.clinic}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sm={6}>
                      <Typography variant="h5">Company</Typography>
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        style={{ paddingLeft: 10 }}
                      >
                        {this.props.details.company}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sm={6}>
                      <Typography variant="h5">Address</Typography>
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        style={{ paddingLeft: 10 }}
                      >
                        {this.props.details.address}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sm={6}>
                      <Typography variant="h5">Shoot Date</Typography>
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        style={{ paddingLeft: 10 }}
                      >
                        {moment(parseInt(this.props.details.date)).format(
                          "MMM D, YYYY hh:mm A"
                        )}
                      </Typography>
                    </Grid>
                    {/* <Grid item xs={12} md={6} sm={6}>
                      <Typography variant="h5">Category</Typography>
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        style={{ paddingLeft: 10 }}
                      >
                        Dentist shoot
                      </Typography>
                    </Grid> */}
                    <Grid item xs={12} md={6} sm={6}>
                      <Typography variant="h5">Status</Typography>
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        style={{ paddingLeft: 10 }}
                      >
                        {this.props.details.status}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
                )}
              </Grid>
            </div>
            {(this.props.fetching && !this.props.fetched) || this.props.status === null ? null : (
              <>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Grid item xs={12} md={6} sm={8}>
                <ClientStaffSection data={this.props.staffs} presentation />
              </Grid>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Grid item xs={12} md={6} sm={8}>
                <ClientLanguageSection
                  data={this.props.languages}
                  presentation
                />
              </Grid>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <Grid item xs={12} md={6} sm={8}>
                <ClientServicesSection
                  data={this.props.services}
                  presentation
                />
              </Grid>
            </div>
            </>
            )}
          </>
       
        <ConfirmationDialog />
        <SendToContractorDialog
          match={this.props.match}
        />
      </ContentWrapper>
    );
  }
}

const mapStateToProps = state => {
  const { startShoot, ...selectedShoot } = state.selectedShoot
  return {
    confirmDialog: state.dialog.confirm.open,
    confirmAction: state.dialog.confirm.action,
    confirmChoice: state.dialog.confirm.confirmed,
    status: state.selectedShoot.status,
    ...selectedShoot
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch),
    shootActions: bindActionCreators(shootActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailsTab);
